const LoggerPlugin = {
  install (Vue, options) {
    let logLevelList = ['DEBUG', 'INFO', 'WARNING', 'ERROR']
    let defaultLogLevel = logLevelList[0]
    let logger = {
      logLevel: defaultLogLevel,
      key: 'chekt::logLevel',
      getLogLevelFromLocalStorage: function () {
        try {
          let targetLogLevel = defaultLogLevel
          let obj = JSON.parse(localStorage.getItem(Vue.logger.key))
          let exp = obj.exp
          let logLevel = obj.value
          let nowTimestamp = new Date().getTime()
          let timeLeft = exp - nowTimestamp
          if (timeLeft > 0 && logLevel) {
            if (logLevelList.indexOf(logLevel) >= 0) {
              targetLogLevel = logLevel
            }
            console.log('LogLevel (get custom log level): ' + targetLogLevel + ': ' + Math.round(timeLeft / 1000) + 's left')
            Vue.logger.setLogLevel(targetLogLevel)
          }
        } catch (err) {}
      },
      removeLogLevelInLocalStorage: function () {
        try {
          localStorage.removeItem(Vue.logger.key)
          console.log('LogLevel (removed custom log level)')
        } catch (err) {}
      },
      storeLogLevelInLocalStorage: function (logLevel) {
        try {
          let targetLogLevel = defaultLogLevel
          if (logLevelList.indexOf(logLevel) >= 0) {
            targetLogLevel = logLevel
          }
          let nowDate = new Date()
          let exp = new Date(nowDate.setHours(nowDate.getHours() + 1)).getTime() // last only 1 hour
          localStorage.setItem(Vue.logger.key, JSON.stringify({value: targetLogLevel, exp: exp}))
          console.log('LogLevel (store custom log level): ' + targetLogLevel)
          Vue.logger.setLogLevel(targetLogLevel)
        } catch (err) {}
      },
      setLogLevel: function (logLevel) {
        let targetLogLevel = defaultLogLevel
        if (logLevelList.indexOf(logLevel) >= 0) {
          targetLogLevel = logLevel
        }
        try {
          Vue.logger.logLevel = targetLogLevel
          console.log('LogLevel: ' + Vue.logger.logLevel)
        } catch (err) {}
      },
      debug: function (str) {
        let logLevel = defaultLogLevel
        try {
          let targetLogLevel = Vue.logger.logLevel
          if (targetLogLevel) logLevel = targetLogLevel
        } catch (err) {}
        if (logLevelList.indexOf(logLevel) <= logLevelList.indexOf('DEBUG')) {
          console.log('DEBUG: ' + ((str instanceof Object) ? JSON.stringify(str, null, 2) : str))
        }
      },
      info: function (str) {
        let logLevel = defaultLogLevel
        try {
          let targetLogLevel = Vue.logger.logLevel
          if (targetLogLevel) logLevel = targetLogLevel
        } catch (err) {}
        if (logLevelList.indexOf(logLevel) <= logLevelList.indexOf('INFO')) {
          console.log('INFO: ' + ((str instanceof Object) ? JSON.stringify(str, null, 2) : str))
        }
      },
      warn: function (str) {
        let logLevel = defaultLogLevel
        try {
          let targetLogLevel = Vue.logger.logLevel
          if (targetLogLevel) logLevel = targetLogLevel
        } catch (err) {}
        if (logLevelList.indexOf(logLevel) <= logLevelList.indexOf('WARNING')) {
          console.warn('WARNING: ' + ((str instanceof Object) ? JSON.stringify(str, null, 2) : str))
          // console.warn(str)
        }
      },
      error: function (str) {
        let logLevel = defaultLogLevel
        try {
          let targetLogLevel = Vue.logger.logLevel
          if (targetLogLevel) logLevel = targetLogLevel
        } catch (err) {}
        if (logLevelList.indexOf(logLevel) <= logLevelList.indexOf('ERROR')) {
          console.warn('ERROR: ' + ((str instanceof Object) ? JSON.stringify(str, null, 2) : str))
          // console.error(str)
        }
      }
    }
    window.setLogLevel = logger.storeLogLevelInLocalStorage
    window.resetLogLevel = logger.removeLogLevelInLocalStorage
    Vue.prototype.$logger = logger
    Vue.logger = logger
  }
}

export default LoggerPlugin



// WEBPACK FOOTER //
// ./src/plugins/logger.js